module.exports = __webpack_public_path__ + "img/applicants-selection-candidates.1b33ce04.svg";